module.exports = __webpack_public_path__ + "img/award-prize-01.ef0141f7.png";